import { FieldTypes } from '../../constants/FieldTypes'
import { Field, FieldMap } from '../../types'
import { conditionsOrDiseasesField } from './conditionsOrDiseases'
import { injuriesAndSurgeriesField } from './injuringAndSurgeries'
import { neurologicalPsychologicalField } from './neurologicalPsychologicalField'

export const healthHistoryHeightField: Field = {
  type: FieldTypes.HEIGHT,
  placeholder: 'Height',
}

export const healthHistoryWeightField: Field = {
  type: FieldTypes.NUMBER,
  placeholder: 'Weight',
  unit: 'lbs',
}

export const healthHistoryField: FieldMap = {
  name: 'Health History',
  children: {
    height: healthHistoryHeightField,
    weight: healthHistoryWeightField,
    conditionsOrDiseases: conditionsOrDiseasesField,
    neurologicalPsychological: neurologicalPsychologicalField,
    injuriesAndSurgeries: injuriesAndSurgeriesField,
  },
}
